import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { OrganizationListComponent } from './pages/organization-list/organization-list.component'
import { OrganizationBranchInformationComponent } from './pages/organization-branch-information/organization-branch-information.component'
import { ViewBusinessDetailsComponent } from './pages/view-business-details/view-business-details.component'
import { OranizationPendingActionsComponent } from './pages/oranization-pending-actions/oranization-pending-actions.component'
import { OrganizationProfileComponent } from './pages/organization-profile/organization-profile.component'
import { OrganizationBranchGalleryComponent } from './pages/organization-branch-gallery/organization-branch-gallery.component'
import { DataResolver } from './resolver/pendingActionPageData.resolver.service'

const routes: Routes = [
	{
		path: '',
		component: OrganizationListComponent,
	},
	{
		path: 'organization-profile',
		children: [
			{
				path: 'booking',
				loadChildren: () =>
					import('../../modules/booking/booking.module').then(
						(m) => m.BookingModule
					),
			},
			{
				path: 'services',
				loadChildren: () =>
					import('../../modules/services/services.module').then(
						(m) => m.ServicesModule
					),
			},
			{
				path: 'branch-rating',
				loadChildren: () =>
					import('../../modules/rating/ratings.module').then(
						(m) => m.RatingsModule
					),
			},
			{
				path: 'chat',
				loadChildren: () =>
					import(
						'../../modules/organization-chat/organization-chat.module'
					).then((m) => m.OrganizationChatModule),
			},
			{
				path: 'packages',
				loadChildren: () =>
					import('../../modules/packages/package.module').then(
						(m) => m.PackageModule
					),
			},
			{
				path: ':id',
				component: OrganizationProfileComponent,
			},
			{
				path: 'branch-information/:branchId/:type',
				component: OrganizationBranchInformationComponent,
			},
			{
				path: 'view-business-details/:id',
				component: ViewBusinessDetailsComponent,
			},
			{
				path: 'organization_gallery/:branchId',
				component: OrganizationBranchGalleryComponent,
			},
		],
	},
	{
		path: 'pending-actions/:id',
		component: OranizationPendingActionsComponent,
		resolve: {
			data: DataResolver,
		},
	},
]

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class OrganizationRoutingModule {}
